app.factory('analyticsService', ['$http', function ($http) {
	var service = this;

	service.event = function(event, params) {
		if (params == null) {
			params = {};
		}
		params.event = event;
		$http.post('/api/analytics/event', params).then(function() {
			console.log("analytics ok!");
		}).catch(function() {
			console.log("analytics bad!");
		});
	}

	return service;
}]);